import {
  cloneListOfCloneable, DataModelBuilder, isSameList, SerializationContext, SerializedData,
} from '../../models/dto/dto.js';
import { Product } from '../../models/serializable/product.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class ProductListComponent extends Component {
  static readonly TYPE_ID: string = '421a3d2bdecc4a0881db2dbcd190406e';

  constructor(
    public readonly products: Product[],
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return ProductListComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ProductListComponent {
    return new ProductListComponent(
        MapUtils.getList(map, 'products', (data) => context.fromData<Product>(data as SerializedData))
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'products': this.products.map((template) => context.toData(template)),
    };
  }

  clone(): this {
    return new ProductListComponent(
        cloneListOfCloneable(this.products),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.products, this.products);
  }
}

export class ProductListComponentBuilder extends DataModelBuilder<ProductListComponent> {
  build(context: SerializationContext, map: SerializedData): ProductListComponent {
    return ProductListComponent.fromMap(context, map);
  }
}
